import type { FuncOverrideComponent } from '../theme.types';

export const MuiDialogContent: FuncOverrideComponent<'MuiDialogContent'> = theme => ({
  styleOverrides: {
    root: {
      padding: theme.spacing(1, 2.5),
    },
  },
});
